<template>
	<div class="box flex-space-around--center" :class="{ selected: isSelected }">
		<span class="first-letter-uppercase">{{ title }}</span>
	</div>
</template>

<script>
export default {
	name: 'TriggerBox',
	props: {
		title: { type: String },
		isSelected: { type: Boolean },
	},
};
</script>
<style lang="scss" scoped>
@import '@/styles/modules/dotted-border-bg.scss';
@import './FlowTreeBlock/styles/choose-node-bg.scss';
$horizontal-padding: 7px;
$selected-vertical-padding: 0px;
.box {
	border-radius: 10px;
	box-shadow: 0px 0px 0px rgba(0, 0, 0, 0) !important;
	transition: all 0.2s;
	padding: 0px $horizontal-padding;
	min-width: 290px;
	max-width: 450px;
	min-height: 45px;
	span {
		color: #474647;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&.selected,
	&:hover {
		@extend .dotted-border-bg;
	}
	&.selected {
		@extend .choose-node-bg;
		background-image: none;
		border-width: 1px;
		border-style: solid;
		padding: $selected-vertical-padding $horizontal-padding;
	}
}
</style>
